import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import Container from '@/components/Atoms/Container'
import Loading from '@/components/Atoms/Loading'
import { Header } from '@/components/ui/header'
import { buildPath, Params } from '@/routes'
import { Suspense, useCallback } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router'
import { AutonomousVehicleApplicationProvider } from '../hooks/ava-provider'
import { AutonomousVehicleSteps } from './AutonomousVehicleSteps'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { TriangleAlertIcon } from 'lucide-react'

export function AutonomousVehicleLayout() {
  // Hooks
  const navigate = useNavigate()
  const { registrationId } =
    useParams<
      Params<'/applications/automated-vehicles/:registrationId/business-info'>
    >()

  const onNotFound = useCallback(() => {
    navigate(buildPath('/applications/automated-vehicles'))
  }, [navigate])

  return (
    <Container className="mt-2 flex flex-col gap-4">
      <Breadcrumb
        label="Automated Motor Vehicle Authorization"
        path={buildPath('/applications/automated-vehicles')}
      />

      <div className="mx-4 flex flex-col gap-6">
        <Header variant="h1" className="text-center">
          Automated Motor Vehicle Authorization
        </Header>

        <Alert className="mx-auto max-w-4xl" variant="warning">
          <TriangleAlertIcon className="size-5" />
          <AlertTitle className="text-base font-bold">
            This sign up is for{' '}
            <span className="underline">
              automated motor vehicle companies only
            </span>
            .
          </AlertTitle>
          <AlertDescription className="text-sm font-medium">
            Do not continue if you are not seeking authorization to operate
            automated motor vehicles in Texas.
          </AlertDescription>
        </Alert>

        <AutonomousVehicleApplicationProvider
          registrationId={registrationId}
          onNotFound={onNotFound}
        >
          <AutonomousVehicleSteps registrationId={registrationId}>
            <Suspense
              fallback={<Loading variant="fullscreen" className="min-h-64" />}
            >
              <Outlet />
            </Suspense>
          </AutonomousVehicleSteps>
        </AutonomousVehicleApplicationProvider>
      </div>
    </Container>
  )
}
